<nav
  tabindex="0"
  #desktopNav
  class="global-nav__wrap"
  [ngClass]="{
    'global-nav__wrap--multi': componentData?.multiNav,
    'global-nav__wrap--modern': componentData?.style === 'modern',
    'global-nav__wrap--siteWide': componentData?.siteWide
  }"
  role="navigation"
>
  <div class="global-nav multi-nav" *ngIf="componentData?.multiNav">
    <div class="multi-nav__inner" [ngClass]="{ 'container my-0': componentData?.siteWide }">
      <a
        id="skip-link"
        role="link"
        class="hidden-focusable-element"
        [attr.aria-label]="'GlobalNav:SkiptoContent'"
        [translate]="'GlobalNav:SkiptoContent'"
        [href]="skipLinkPath"
      >
        Skip to content
      </a>
      <section class="global-nav__section global-nav__section--logo">
        <a class="global-nav__logo" role="link" href routerLink="/" (accessibleClick)="navigate('/')">
          <img
            class="global-nav__logo-image"
            alt="{{ clientName }} Concierge Service delivered by TEN"
            [src]="componentData?.multiNavLogo"
          />
        </a>
      </section>
      <section class="multi-nav-menu-group">
        <div class="multi-nav-button-group">
          <button
            mat-button
            (mouseover)="hoverOpenMenu()"
            (mouseout)="hoverCloseMenu($event)"
            [matMenuTriggerFor]="menu"
            [attr.aria-role]="'Menu'"
            class="pin-menu"
            color="accent"
            *ngIf="(member_profile$ | async)?.navigation_links?.length > 0"
          >
            <i class="material-icons" aria-hidden="true"> apps </i>
          </button>
          <mat-menu #menu="matMenu" [hasBackdrop]="false" [overlapTrigger]="false" (closed)="pinMenuOpen = false">
            <button
              mat-menu-item
              *ngFor="let link of (member_profile$ | async)?.navigation_links"
              (accessibleClick)="navigate(link)"
            >
              <a tabindex="0" [href]="link.link" role="link" class="mutli-nav-menu-link">{{ link.title }}</a>
            </button>
          </mat-menu>

          <button
            mat-button
            class="multi-nav-log-out-btn"
            (click)="logoutUser()"
            (keyup.enter)="logoutUser()"
            (keyup.space)="logoutUser()"
          >
            <span [translate]="'GlobalNav:NavLogout'">Log out</span>
          </button>
        </div>
        <span class="last-login username" *ngIf="(member_profile$ | async)?.username">
          {{ (member_profile$ | async)?.username }} |
        </span>
        <span class="last-login" *ngIf="(member_profile$ | async)?.last_login">
          {{ 'GlobalNav:Lastlogin' | translate }}
          {{ (member_profile$ | async)?.last_login | customDatePipe: 'LLLL' }}
        </span>
      </section>
    </div>
  </div>
  <div class="global-nav" [class.fix-height]="!componentData?.siteWide">
    <div
      class="global-nav__inner"
      [class.container-xl]="componentData?.siteWide && componentData?.style !== 'modern'"
      [class.my-0]="componentData?.siteWide"
    >
      <p id="desktop-nav" class="hidden-focusable-element" aria-label="Main navigation menu">Main navigation menu</p>
      <a
        id="skip-link"
        role="link"
        tabindex="0"
        class="hidden-focusable-element"
        [attr.aria-label]="'GlobalNav:SkiptoContent'"
        [translate]="'GlobalNav:SkiptoContent'"
        (accessibleClick)="navigateToSkipLinkPathOrFocusOnElem(); $event.preventDefault()"
      >
        Skip to content
      </a>
      <section class="global-nav__section global-nav__section--logo">
        <a
          class="global-nav__logo"
          [ngClass]="{ 'pl-0': componentData?.siteWide }"
          id="global-nav-logo"
          role="link"
          href
          routerLink="/"
          *ngIf="componentData?.logo"
          (accessibleClick)="navigate('/')"
        >
          <img
            *ngIf="siteLogo$ | async as siteLogo"
            class="global-nav__logo-image"
            [class.modern__logo-image]="componentData?.buttonContainerStyle === 'modern'"
            alt="{{ clientName }} Concierge Service delivered by TEN"
            [src]="siteLogo"
          />
        </a>
      </section>
      <section
        *ngIf="showFeatureNavLinks && siteSettingsLoaded"
        class="global-nav__section global-nav__section--main-menu"
      >
        <ng-container *ngFor="let menu of menuList$ | async; index as i">
          <span
            *ngIf="menu.isVisible"
            class="global-nav__item-wrap"
            (mouseover)="onMenuItemMouseOver(menu.id)"
            (mouseleave)="onMenuItemMouseLeave(menu.id)"
          >
            <a
              href
              role="link"
              [id]="menu.id"
              class="global-nav__item"
              [routerLink]="menu.routerLink"
              (focus)="onMenuItemMouseOver(menu.id)"
              [attr.aria-current]="routerLink.isActive"
              routerLinkActive="is-selected"
              #routerLink="routerLinkActive"
              (accessibleClick)="navigate(menu.routerLink, 'onMenuItemClick')"
            >
              {{ menu.customName || menu.translate | translate }}
            </a>

            <ten-sitemap-header
              *ngIf="menu.id === 'nav_benefits'"
              class="sitemap-header container-xl"
              [ngClass]="{ active: showBenefitsNav }"
            ></ten-sitemap-header>
          </span>
        </ng-container>
        <span
          *ngIf="externalPortal?.link && externalPortal?.name && componentData?.externalLinkType === 'simple'"
          class="global-nav__item-wrap"
        >
          <a
            [href]="externalPortal?.link"
            role="link"
            target="_blank"
            rel="noopener noreferrer"
            class="global-nav__item global-nav__external-portal-simple"
            (focus)="showBenefitsNav = false"
          >
            {{ externalPortal?.name | translate }} <mat-icon>launch</mat-icon>
          </a>
        </span>
      </section>

      <section
        *ngIf="siteSettingsLoaded"
        class="global-nav__section global-nav__section--alt-menu"
        [class.global-nav__section--modern]="componentData?.iconMenuStyle === 'modern'"
        [class.display-content]="componentData?.siteWide"
        [ngClass]="{ 'pr-0': componentData?.siteWide }"
      >
        <a
          mat-stroked-button
          *ngIf="externalPortal?.link && externalPortal?.name && componentData?.externalLinkType !== 'simple'"
          [href]="externalPortal?.link"
          (focus)="showBenefitsNav = false"
          class="global-nav__external-portal"
        >
          {{ externalPortal?.name | translate }}
        </a>

        <!-- Platform provider info. -->
        <div
          *ngIf="showPlatformProvider && platformProviderType === 'provider' && isAccessHrt"
          class="platform-provider"
        >
          <div class="platform-provider__text" [translate]="'GlobalNav:ServiceProvidedBy'">Service provided by</div>
          <div
            role="img"
            class="platform-provider__icon"
            [attr.aria-label]="'GlobalNav:ProviderLogo' | translate"
          ></div>
        </div>
        <div *ngIf="showPlatformProvider && platformProviderType === 'delivered'" class="platform-provider">
          <div class="platform-provider__text" [translate]="'GlobalNav:DeliveredBy'">Delivered by Ten</div>
        </div>
        <div *ngIf="showPlatformProvider && platformProviderType === 'partnership'" class="platform-provider">
          <div class="platform-provider__text" [translate]="'GlobalNav:InPartnerShipWith'">In partnership with</div>
          <div
            role="img"
            class="platform-provider__icon"
            [attr.aria-label]="'GlobalNav:ServiceProvidedBy' | translate"
          ></div>
        </div>

        <!-- Other menu items. -->
        <div
          class="global-nav__icon-menu-wrap"
          [class.global-nav__icon-menu-wrap--modern]="componentData?.iconMenuStyle"
        >
          <ng-container *ngIf="appFeatures?.enable_pay_with_points && memberPayWithPointsEnabled">
            <button
              cdk-overlay-origin
              #payWithPointsPopup="cdkOverlayOrigin"
              class="global-nav__icon-menu-item"
              aria-label="pay with points"
              id="global-nav.pay-with-points"
              (accessibleClick)="payWithPointsPopupOpened = !payWithPointsPopupOpened"
            >
              <img src="assets/images/header/ic-card-membership.svg" alt="" />
            </button>
            <ng-template
              cdk-connected-overlay
              [cdkConnectedOverlayOrigin]="payWithPointsPopup"
              cdkConnectedOverlayHasBackdrop
              cdkConnectedOverlayBackdropClass="cdk-overlay-transparent-backdrop"
              cdkConnectedOverlayPanelClass="pay-with-points-overlay"
              [cdkConnectedOverlayOffsetY]="10"
              [cdkConnectedOverlayOpen]="payWithPointsPopupOpened"
              (backdropClick)="payWithPointsPopupOpened = false"
            >
              <ten-pay-with-points-popup
                [points]="points$ | async"
                [displayNote]="displayPayWithPointsNote$ | async"
                [showDescription]="true"
                (closed)="payWithPointsPopupOpened = false"
              ></ten-pay-with-points-popup>
            </ng-template>
          </ng-container>
          <a
            *ngIf="appFeatures?.preferences_page"
            class="global-nav__icon-menu-item"
            aria-label="preferences"
            role="link"
            tabindex="0"
            href
            routerLink="/preferences"
            routerLinkActive="is-selected"
            id="global-nav.preferences"
            (accessibleClick)="navigate('/preferences', 'onMenuUserProfileClick')"
          >
            <mat-icon class="menu-icon" *ngIf="componentData?.iconMenuStyle !== 'modern'">favorite</mat-icon>
            <img src="assets/images/header/preference.svg" alt="" *ngIf="componentData?.iconMenuStyle === 'modern'" />
          </a>
          <a
            class="global-nav__icon-menu-item"
            aria-label="account"
            role="link"
            tabindex="0"
            href
            routerLink="/member"
            routerLinkActive="is-selected"
            tourAnchor="global-nav.person"
            id="global-nav.person"
            (accessibleClick)="navigate('/member', 'onMenuUserProfileClick')"
          >
            <mat-icon class="menu-icon" *ngIf="componentData?.iconMenuStyle !== 'modern'">person</mat-icon>
            <img src="assets/images/header/user.svg" alt="" *ngIf="componentData?.iconMenuStyle === 'modern'" />
          </a>
          <a
            class="global-nav__icon-menu-item"
            aria-label="menu"
            role="link"
            data-toggle="modal"
            tabindex="0"
            data-target="#id01"
            (click)="toggleMobileNavigation(true)"
            tourAnchor="global-nav.menu"
            id="global-nav.menu"
            (keyup.enter)="toggleMobileNavigation(true)"
            (keyup.space)="toggleMobileNavigation(true)"
          >
            <mat-icon class="menu-icon" *ngIf="componentData?.iconMenuStyle !== 'modern'">menu</mat-icon>
            <img src="assets/images/header/menu.svg" alt="" *ngIf="componentData?.iconMenuStyle === 'modern'" />
          </a>
        </div>
      </section>
    </div>
  </div>
</nav>

<div class="global-nav__placeholder"></div>

<div
  role="button"
  aria-label="Close"
  class="parent-overlay"
  *ngIf="menuState === 'in'"
  (click)="toggleMobileNavigation(false)"
  (keyup.enter)="toggleMobileNavigation(false)"
  (keyup.space)="toggleMobileNavigation(false)"
></div>

<nav [@slideInOut]="menuState" class="overlay" *ngIf="showMobileNavOverlay" id="mobile-nav" aria-label="Main">
  <ten-mobile-nav
    [siteSettingsLoaded]="siteSettingsLoaded"
    [showFeatureNavLinks]="showFeatureNavLinks"
    [appFeatures]="appFeatures"
    [externalPortal]="externalPortal"
    [menuList]="menuList$ | async"
    [memberProfile$]="member_profile$"
    [isUserLoggedIn]="true"
    (closed)="toggleMobileNavigation(false)"
    (logout)="logoutUser()"
  >
  </ten-mobile-nav>
</nav>
